<div class="mobilize-modal">
    <div class="modal-title">Modifica data de emitere</div>

    <div class="modal-content">
        <mat-form-field>
            <mat-label>Noua scadenta</mat-label>
            <mat-select [(ngModel)]="dueDate">
                <mat-option value="1" [disabled]="currentDay === '1'">1 ale lunii</mat-option>
                <mat-option value="10" [disabled]="currentDay === '10'">10 ale lunii</mat-option>
                <mat-option value="20" [disabled]="currentDay === '20'">20 ale lunii</mat-option>
            </mat-select>
        </mat-form-field>

        <div class="disclaimer">
            <span>Schimbarea datei de emitere a ratei va fi evidentiata incepand cu luna urmatoare!</span>
        </div>
    </div>

    <div class="modal-buttons">
        <button class="mobilize-btn btn-clear" (click)="close(false)">renunt</button>
        <button class="mobilize-btn btn-orange" [disabled]="!dueDate" (click)="close(true)">confirm</button>
    </div>
</div>
